import { Component, OnInit, OnDestroy }            from '@angular/core';
import { RouteOptions }                 from './../../../../../models/route-options';
import { ActivatedRoute, Params }       from '@angular/router';
import { ProgramRoutesService }         from './../../program-routes.service';
import { GroupService }                 from './../../../group.service';
import { InTeamLevelService } from '../../in-team-level.service';

import { Subscription }                 from 'rxjs/Subscription';
import { combineLatest }                from 'rxjs/observable/combineLatest';

@Component({
  selector: 'app-group-shell',
  templateUrl: './group-shell.component.html',
  styleUrls: ['./group-shell.component.less']
})
export class GroupShellComponent implements OnInit, OnDestroy {

  public links: RouteOptions[] = [
    { ref: ['general-settings'], title: 'General Settings' },
    { ref: ['schedule'], title: 'Schedule' },
    { ref: ['notifications'], title: 'Notifications' }
  ];
  private subs: Subscription[] = [];
  private programId: any;
  private groupId: any;
  private level: Number;
  public inTeamDeeperLevel: boolean;

  constructor(
    public inTeamLevelService: InTeamLevelService,
    private route: ActivatedRoute,
    private _programRoutes: ProgramRoutesService,
    private groupService: GroupService
  ) { }

  ngOnInit() {
    this.programId = this.groupService.processRouteForParentId(this.route.snapshot);
    this.subs.push(this.route.parent.params.subscribe(params => {
      this.groupId = +params['groupId'];
    }));
    this.subs.push(this.route.url.subscribe(urlArray => {
      // Re-evaluate the navigation bar when routing occurs
      if (this.links.length > 4) {
        this.links.shift();
      }
      let categoryId = urlArray[1].path;
      if (urlArray[0].path === 'waves') {
        this.links.unshift({ ref: ['teams'], title: 'Teams' });
        this.links[4] = { ref: ['/analytics/snapshot', {wave: categoryId, programId: this.programId}], title: 'Go to Analytics' }
      } else {
        this.links.unshift({ ref: ['users'], title: 'Users' });
        this.links[4] = { ref: ['/analytics/snapshot', {group: categoryId, programId: this.programId}], title: 'Go to Analytics' }
      }
    }));
    this.subs.push(combineLatest(this.inTeamLevelService.inTeamLevel, this.route.data)
      .subscribe(([deepestLevel, data]) => {
        this.inTeamDeeperLevel = (deepestLevel > data.currentLevel)
      })
    )
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
    this._programRoutes.name.next(null);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/group-shell/group-shell.component.ts